import { ReactElement, useContext, useState } from "react";
import { useCookies } from "react-cookie";

import ConfirmDialog from "../../../../components/dialogs/confirm";
import useDeleteCollectionAssets from "../../../../hooks/mutation/assets/use-delete-collection-assets";
import { CollectionAssetsContext } from "../../../../providers/collection-assets-provider";
import CollectionAssetEmpty from "../../../../sections/collection/CollectionAssetEmpty";
import CollectionAssetGrid from "../../../../sections/collection/CollectionAssetGrid";
import CollectionAssetList from "../../../../sections/collection/CollectionAssetList";
import { ConfirmationModalType } from "../../../../types/confirm-modal";
import { ListLayout } from "../../../../types/list";

type Props = {
  collectionId: string;
};

export default function CollectionItems(props: Props): ReactElement {
  const { collectionId } = props;

  const [confirmationModal, setConfirmationModal] = useState<
    ConfirmationModalType | undefined
  >(undefined);
  const { assets, collectionAssetsChanged } = useContext(
    CollectionAssetsContext
  );
  const { deleteCollectionAssets } = useDeleteCollectionAssets();
  const [cookies] = useCookies();

  const handleDelete = async (): Promise<void> => {
    if (!confirmationModal?.id) {
      return;
    }

    await deleteCollectionAssets(collectionId, [confirmationModal?.id]);
    await collectionAssetsChanged();

    setConfirmationModal(undefined);
  };

  if (!assets || !assets?.length) {
    return <CollectionAssetEmpty />;
  }

  return (
    <>
      {cookies.listLayout === ListLayout.List ? (
        <CollectionAssetList
          collectionId={collectionId}
          assets={assets}
          setConfirm={setConfirmationModal}
        />
      ) : (
        <CollectionAssetGrid
          collectionId={collectionId}
          assets={assets}
          setConfirm={setConfirmationModal}
        />
      )}
      {confirmationModal?.isOpen && (
        <ConfirmDialog
          header="Delete from Collection"
          text="The Asset(s) will be removed from this collection only. The Asset(s) will still be visible in other collections and in the File-System."
          isOpen={confirmationModal.isOpen}
          onClose={() => setConfirmationModal(undefined)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
}
